import script from "./EventScheduleTab.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventScheduleTab.vue?vue&type=script&lang=ts&setup=true"

import "./EventScheduleTab.vue?vue&type=style&index=0&id=f0bc9548&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0bc9548"]])

export default __exports__